export default "__VITE_ASSET__0eeabcd6__"